
export default class SubscriptionQuizApp {

  constructor() {
    let _this = this;

    this.tariffData = {
      free: 1,
      basic: 2,
      standard: 3,
      premium: 4
    };
  }

  init() {
    let _this = this;
      //console.log('DOMContentLoaded, init Subscription Quiz');

      _this.initSubscriptionQuiz();
  }

  initSubscriptionQuiz() {
    let _this = this;
    //console.log("initSubscriptionQuiz()");

    _this.calculatePlan(1);

    $('.sb-js--select, .sb-js--switch input[type="checkbox"]').change(function () {
      console.log("change");
      var bookings = _this._geteBookings();
      var plugins = _this._getPlugins();
      var weight = _this._getWeight();

      var value = _this._getValue(plugins, bookings, weight);

      _this.calculatePlan(value);

    }.bind(_this));
  }

  calculatePlan(value) {
    //console.log("calculatePlan() value: ", value);

    let $planWrapper = $('.sb-js--plans-wrapper');
    let $planBtnBar = $('.sb-js--plan-bar');

    if (this.tariffData.free >= value) {
      let tariffName = $('.sb-js--plan.free').data('name');
      $planWrapper.attr('data-name', tariffName);

      $('.sb-js--plan.free').addClass('in').show().siblings().removeClass('in').hide();
      $planBtnBar.show();
    }
    else if (this.tariffData.basic >= value) {
      let tariffName = $('.sb-js--plan.basic').data('name');
      $planWrapper.attr('data-name', tariffName);

      $('.sb-js--plan.basic').addClass('in').show().siblings().removeClass('in').hide();
      $planBtnBar.show();
    }
    else if (this.tariffData.standard >= value) {
      let tariffName = $('.sb-js--plan.standard').data('name');
      $planWrapper.attr('data-name', tariffName);

      $('.sb-js--plan.standard').addClass('in').show().siblings().removeClass('in').hide();
      $planBtnBar.show();
    }
    else if (this.tariffData.premium >= value) {
      let tariffName = $('.sb-js--plan.premium').data('name');
      $planWrapper.attr('data-name', tariffName);

      $('.sb-js--plan.premium').addClass('in').show().siblings().removeClass('in').hide();
      $planBtnBar.show();
    }
    else {
      let tariffName = $('.sb-js--plan.contact-us').data('name');
      $planWrapper.attr('data-name', tariffName);

      $('.sb-js--plan.contact-us').addClass('in').show().siblings().removeClass('in').hide();
      $planBtnBar.hide();
    }
  }

  _getValue(plugins, bookings, weight) {
    var value = 0;

    //free
    if (plugins <= 2 && bookings <= 25) {
      value = 1;
    }
    //basic
    else if (plugins <= 3 && bookings <= 100) {
      value = 2
    }
    //standard
    else if (plugins <= 8 && bookings <= 500) {
      value = 3
    }
    //premium
    else if (plugins <= 35 && bookings <= 2000) {
      value = 4
    }
    //custom
    else {
      value = 5
    }

    if (weight) {
      if (weight > value) {
        return weight
      } else {
        return value
      }
    }

    return value;
  }

  _geteBookings() {
    return $('.sb-js--select').val() * 23;
  }

  _getPlugins() {
    return $('.sb-js--switch input[type="checkbox"]').filter(':checked').length;
  }

  _getWeight() {

    var weight = 0;

    if ($('#input-bisiness_management-22').is(':checked')) {
      //make custom or / another one
      weight = 5;
    }
    if ($('#input-bisiness_management-23').is(':checked')) {
      //make custom or / another one
      weight = 5;
    }

    return weight;
  }
}

document.addEventListener("DOMContentLoaded", () => {
  //console.log('DOMContentLoaded, init Subscription Quiz');
  const subscriptionQuizApp = new SubscriptionQuizApp();
  subscriptionQuizApp.init();
});